import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { RepositoryModal, Right, Role } from '../../shared'

@Component({
    templateUrl: './role.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class RoleComponent extends RepositoryModal<Role> implements OnInit {
    rights: Right[] = []

    ngOnInit() {
        this.rights = this.services.data.rights.items.slice()
        this.rights.forEach(x => {
            if (this.target.rightsIds.indexOf(x.id) > -1) x['checked'] = true
            else x['checked'] = false
        })
    }

    protected onBeforeSave() {
        this.target.rightsIds = this.rights.filter(x => x['checked']).map(x => x.id)
        return super.onBeforeSave()
    }
}
